module.exports = __webpack_public_path__ + "static/media/manage.1f519ed1.svg";